import { forwardRef, type JSX } from 'react';
import type { PolymorphicRef, PolymorphicComponentPropWithRef } from '../types';
import styles from './text.module.css';
import clsx from 'clsx';

export type TextProps<As extends React.ElementType = 'p'> =
  PolymorphicComponentPropWithRef<
    As,
    {
      size?: 'inherit' | 'body' | 'lead' | 'large' | 'small';
      weight?: '400' | '500' | '700' | 400 | 500 | 700;
    }
  >;

const TextComp = <As extends React.ElementType = 'p'>(
  { as, className, size = 'inherit', weight = 400, ...rest }: TextProps<As>,
  ref: PolymorphicRef<As>
) => {
  const Tag = as || 'p';
  const classes = clsx(
    className,
    styles.text,
    styles[size],
    styles[`weight-${weight}`]
  );

  return <Tag className={classes} ref={ref} {...rest} />;
};

export const Text = forwardRef<null>(TextComp) as <
  As extends React.ElementType = 'p'
>(
  props: TextProps<As>
) => JSX.Element;

(Text as React.FC).displayName = 'Text';
